enum LogLevel {
  DEBUG = "debug",
  INFO = "info",
  WARN = "warn",
  ERROR = "error",
}

class Logger {
  private static log(
    level: LogLevel,
    message: string,
    ...optionalParams: any[]
  ): void {
    if (process.env.REACT_APP_ENVIORNMENT === "PRODUCTION") {
      return;
    }

    const timestamp = new Date().toISOString();
    console[level](
      `[${timestamp}] [${level.toUpperCase()}] ${message}`,
      ...optionalParams,
    );
  }

  static debug(message: string, ...optionalParams: any[]): void {
    this.log(LogLevel.DEBUG, message, ...optionalParams);
  }

  static info(message: string, ...optionalParams: any[]): void {
    this.log(LogLevel.INFO, message, ...optionalParams);
  }

  static warn(message: string, ...optionalParams: any[]): void {
    this.log(LogLevel.WARN, message, ...optionalParams);
  }

  static error(message: string, ...optionalParams: any[]): void {
    this.log(LogLevel.ERROR, message, ...optionalParams);
  }
}

export default Logger;
